import { Injectable } from '@angular/core';

@Injectable()
export class AdminService {

  isAdmin: boolean = null;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts